import styles from './ExternalFooter.module.scss';

const ExternalFooter = () => {
  return (
    <div className={styles.externalFooterWrapper}>
      <div className="container">
        <div className={styles.externalFooter}>
          <div>
            <LinkBlock {...LEGAL_BLOCK} />
            <LinkBlock {...COMPANY_BLOCK} />
          </div>
          <div>
            <LinkBlock {...KNOW_MORE_BLOCK} />
          </div>
          <div>
            <LinkBlock {...RESOURCES} />
          </div>
          <div>
            <LinkBlock {...ENGAGE} />
          </div>
        </div>
      </div>
    </div>
  );
};

interface LinkBlockProps {
  title: string;
  links: {
    url: string;
    name: string;
  }[];
}

const LinkBlock = ({ title, links }: LinkBlockProps) => (
  <div className={styles.block}>
    <div className={styles.title}>{title}</div>
    {links.map(({ url, name }, idx) => (
      <a key={idx} href={url}>
        {name}
      </a>
    ))}
  </div>
);

const LEGAL_BLOCK: LinkBlockProps = {
  title: 'Legal',
  links: [
    {
      url: '#',
      name: 'Terms & Policies'
    }
  ]
};

const COMPANY_BLOCK: LinkBlockProps = {
  title: 'Company',
  links: [
    {
      url: '#',
      name: 'Public Roadmap'
    },
    {
      url: '#',
      name: 'Our Team'
    },
    {
      url: '#',
      name: 'Jobs'
    }
  ]
};

const KNOW_MORE_BLOCK: LinkBlockProps = {
  title: 'Know More',
  links: [
    {
      url: '#',
      name: 'Referrals'
    },
    {
      url: '#',
      name: 'The Monitoring Service'
    },
    {
      url: '#',
      name: 'LaunchDarkly vs ConfigCat'
    },
    {
      url: '#',
      name: 'Monitoring Tools'
    },
    {
      url: '#',
      name: 'Customer Success Story'
    }
  ]
};

const RESOURCES: LinkBlockProps = {
  title: 'Help & Resources',
  links: [
    {
      url: '#',
      name: 'Docs'
    },
    {
      url: '#',
      name: 'Integrations'
    },
    {
      url: '#',
      name: 'Blog'
    },
    {
      url: '#',
      name: 'Support & Feedback'
    },
    {
      url: '#',
      name: 'Bug Bounty Program'
    }
  ]
};

const ENGAGE: LinkBlockProps = {
  title: 'Engage',
  links: [
    {
      url: '#',
      name: 'Talk with our team on Slack'
    },
    {
      url: '#',
      name: 'Twitter'
    },
    {
      url: '#',
      name: 'Facebook'
    },
    {
      url: '#',
      name: 'LinkedIn'
    },
    {
      url: '#',
      name: 'Leave a review'
    }
  ]
};

export default ExternalFooter;
